/**
 * Pretty messages to show the user based on status code
 */
export const ERROR_STATUS_MESSAGES = {
  400: 'Your request resulted in an error.',
  404: 'We could not find the page you were looking for.',
  500: 'An error occurred, that we could not foresee.',
};

export const getError = error => {
  return {
    statusCode: error?.response?.status,
    ...error?.response?.data,
  };
};

export const PL_NUMBER_INVALID_MESSAGE =
  'PL numbers must use the format PL-XXXXXXX or PL-OTHER.';

export const END_DATE_NOT_AFTER_START_DATE_MESSAGE =
  'The end date must be after the start date.';

export const END_DATE_MUST_BE_IN_FUTURE =
  'Please select an end date in the future.';

export const QUOTA_MUST_BE_ABOVE_ZERO = 'Please enter a positive quota.';

export const formatErrorMsg = error => {
  return [error?.message, error?.body?.message].filter(m => m).join(': ');
};
